import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payoutpage',
  templateUrl: './payoutpage.component.html',
  styleUrls: ['./payoutpage.component.sass']
})
export class PayoutpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
